import ConnectButton from '../../modules/ConnectButton';

const MigrateDisconnected = () => {
  return (
    <div className="rounded-xl bg-gray-800 col-span-1 lg:col-span-6 flex flex-col">
      <h1 className="border-b border-gray-400 px-6  py-5 text-xl text-center">
        {'Migrate FLOOR to V2'}
      </h1>
      <section className="p-6 relative flex-1 flex justify-center">
        <ConnectButton />
      </section>
    </div>
  );
};

export default MigrateDisconnected;
